import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["table", "config"]

  connect() {
    // Funnel controller connected
  }

  toggleTable() {
    const table = this.tableTarget
    const button = event.target.closest('button')
    const icon = button.querySelector('i')
    
    if (table.classList.contains('show')) {
      table.classList.remove('show')
      button.classList.remove('rotated')
    } else {
      table.classList.add('show')
      button.classList.add('rotated')
    }
  }

  toggleConfig() {
    const config = this.configTarget
    const button = event.target.closest('button')
    const icon = button.querySelector('i')
    
    if (config.classList.contains('show')) {
      config.classList.remove('show')
      button.classList.remove('rotated')
    } else {
      config.classList.add('show')
      button.classList.add('rotated')
    }
  }

  updateFunnel() {
    // Hier können wir AJAX-Calls machen um die Funnel-Daten zu aktualisieren
    
    // Beispiel: Filter ändern und Daten neu laden
    const formData = new FormData()
    formData.append('time_filter', this.element.querySelector('select[name="time_filter"]').value)
    formData.append('status_filter', this.element.querySelector('select[name="status_filter"]').value)
    
    fetch(window.location.href, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'text/javascript'
      }
    })
    .then(response => response.text())
    .then(html => {
      // Update nur den Funnel-Bereich
      this.element.innerHTML = html
    })
    .catch(error => {
      // Error updating funnel
    })
  }
}
